import React from 'react';
import { Icon, IconsEnum } from 'components/Icons';

import { scommessaRemoved } from 'features/virtual/components/virtualTicket/virtualTicketSlice';
import styles from './VirtualTicketItemEsito.module.scss';
import { useAppDispatch } from 'lib/centralStore';

export type VirtualTicketItemEsitoProps = {
  esitoId?: string;
  isActive: boolean;
  cancelBtn: boolean;
  descrizioneEsito?: string;
  quotaDividedHundred: number;
  descrizioneTipoScommessa?: string;
};
export const VirtualTicketItemEsito = ({
  esitoId,
  isActive,
  cancelBtn,
  descrizioneEsito,
  quotaDividedHundred,
  descrizioneTipoScommessa,
}: VirtualTicketItemEsitoProps) => {
  const dispatch = useAppDispatch();

  return (
    <React.Fragment key={`ticket-esito-${esitoId}`}>
      <li className={styles.scommessaItem}>
        {/* TODO quando ci sarà esitoIsSospeso <p className={`${styles.scommessa} ${esitoIsSospeso ? styles.disabled : ''}`}> */}
        <p className={styles.scommessa}>
          {descrizioneTipoScommessa}:<span className={styles.esito}>{descrizioneEsito}</span>
        </p>
        <div className={styles.quota}>
          {isActive ? (quotaDividedHundred < 10 ? quotaDividedHundred.toFixed(2) : quotaDividedHundred) : '-'}
          {cancelBtn && (
            <button type="button" className={`${styles.cancelBtn}`} onClick={() => dispatch(scommessaRemoved(esitoId))}>
              <Icon
                iconId={IconsEnum.CANCEL_FULL}
                className={styles.cancelIcon}
                color={'var(--color-on-bg-secondary)'}
              />
            </button>
          )}
        </div>
      </li>
    </React.Fragment>
  );
};